import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './LeadForm.css';

const LeadForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    if (type === 'checkbox') {
      setAgreedToTerms(checked);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!agreedToTerms) {
      setError('יש לאשר את תנאי השימוש ומדיניות הפרטיות.');
      return;
    }

    setIsSubmitting(true);
    setError(null);

    try {
      const response = await fetch('https://hook.eu2.make.com/2t459gwcwzl5ywtmjunkpke62g4hspg1', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          timestamp: new Date().toISOString(),
          source: 'website_lead_form'
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to submit form');
      }

      // Reset form after successful submission
      setFormData({
        name: '',
        phone: '',
        email: ''
      });
      
      // Show success message
      setSuccess(true);
    } catch (err) {
      console.error('Error submitting form:', err);
      setError('אירעה שגיאה בשליחת הטופס. אנא נסה שוב מאוחר יותר.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>צור קשר - אוטוקרוס | השאירו פרטים ונחזור אליכם</title>
        <meta name="description" content="השאירו פרטים ונחזור אליכם בהקדם. אוטוקרוס - פתרונות רכב מתקדמים, מימון, שירות ותחזוקה. צרו קשר עכשיו לקבלת ייעוץ מקצועי." />
        <meta name="keywords" content="אוטוקרוס, רכב, מימון רכב, שירות רכב, תחזוקה רכב, רכב יד שנייה, רכב חדש, ליסינג, השכרת רכב, ייעוץ רכב, ישראל" />
        <meta name="author" content="אוטוקרוס" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="צור קשר - אוטוקרוס" />
        <meta property="og:description" content="השאירו פרטים ונחזור אליכם בהקדם. אוטוקרוס - פתרונות רכב מתקדמים." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="צור קשר - אוטוקרוס" />
        <meta name="twitter:description" content="השאירו פרטים ונחזור אליכם בהקדם. אוטוקרוס - פתרונות רכב מתקדמים." />
      </Helmet>
      <section className="lead-form-section">
        <div className="container">
          <div className="form-container">
            <h2>נשמח לעזור לך!</h2>
            <p>השאירו פרטים ונחזור אליכם בהקדם</p>
            <form onSubmit={handleSubmit} className="lead-form">
              {error && <div className="error-message">{error}</div>}
              {success && <div className="success-message">תודה! פרטיך נשלחו בהצלחה.</div>}
              
              <div className="form-group">
                <label htmlFor="name">שם מלא</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="הכנס את שמך המלא"
                  required
                  disabled={isSubmitting}
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">מספר טלפון</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="הכנס את מספר הטלפון שלך"
                  required
                  disabled={isSubmitting}
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">אימייל</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="הכנס את כתובת האימייל שלך"
                  disabled={isSubmitting}
                />
              </div>

              <div className="form-group terms-checkbox">
                <div className="checkbox-wrapper">
                  <input 
                    type="checkbox" 
                    id="terms"
                    name="terms"
                    checked={agreedToTerms}
                    onChange={handleChange}
                    required 
                    disabled={isSubmitting}
                    aria-describedby="terms-description"
                  />
                  <label htmlFor="terms" id="terms-description">
                    אני מאשר/ת את{' '}
                    <a href="/terms-of-use" target="_blank" rel="noopener noreferrer" aria-label="תנאי השימוש (נפתח בחלון חדש)">
                      תנאי השימוש
                    </a>
                    {' '}ו
                    <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" aria-label="מדיניות הפרטיות (נפתח בחלון חדש)">
                      מדיניות הפרטיות
                    </a>
                    {' '}ומסכים/ה לשמירת פרטיי ויצירת קשר.
                  </label>
                </div>
              </div>

              <button 
                type="submit" 
                className="submit-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'שולח...' : 'שלח פרטים'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default LeadForm; 